/**
 *
 * 方案汇报 - 模型剖切 1.0
 *
 * 功能点:模型根据面进行剖切.
 * 场景:方案汇报
 *
 */
import Vue from "@/main";

let currentModelId;
let tileSetPlanClip = null;
let tileSetPlanClip2 = null;
let graphicLayer;
export let fixedRoute;

graphicLayer = new mars3d.layer.GraphicLayer();
Vue.$GLOBAL.map.addLayer(graphicLayer);

// const graphic = new mars3d.graphic.PointEntity({
//   position: [118.53310889, 24.82462891, 16.8],
//   style: {
//     color: "#ff0000",
//     pixelSize: 10,
//     outlineColor: "#ffffff",
//     outlineWidth: 2,
//     label: {
//       text: "我是原始点",
//       font_size: 18,
//       color: "#ffffff",
//       pixelOffsetY: -10,
//       distanceDisplayCondition: true,
//       distanceDisplayCondition_far: 500000,
//       distanceDisplayCondition_near: 0,
//     },
//   },
//   attr: { remark: "示例1" },
// });
// graphicLayer.addGraphic(graphic);

export function addPlanClipThing2(modelId, positions, val) {
  //添加新的剖切效果
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  if (tilesetLayer) {
    if (currentModelId == modelId) {
      if (tileSetPlanClip2) {
        console.log(val);
        // tileSetPlanClip2.options.distance = val;
        tileSetPlanClip2.distance = val;
      }
    } else {
      //去除已有剖切效果
      // if (tileSetPlanClip2 && Vue.$GLOBAL.map.hasThing(tileSetPlanClip2)) {
      //   tileSetPlanClip2.clear();
      //   Vue.$GLOBAL.map.removeThing(tileSetPlanClip2, true);
      // }

      tileSetPlanClip2 = new mars3d.thing.TilesetPlanClip({
        positions: positions,
        layer: tilesetLayer,
        clipOutSide: false,
        edgeColor: Cesium.Color.GREY,
        edgeWidth: 2.0,
        type: mars3d.ClipType.ZR,
        distance: 13.5,
      });
      Vue.$GLOBAL.map.addThing(tileSetPlanClip2);
    }
    currentModelId = modelId;
  } else {
    Vue.$alert("模型ID无效。", "友情提示", {
      confirmButtonText: "确定",
      type: "warning",
      callback: (action) => {},
    });
  }
}
export function startFixedRoute(arr) {
  fixedRoute = new mars3d.graphic.FixedRoute({
    name: "空中漫游",
    frameRate: 1,
    speed: 40,
    // autoStop: true, // 到达终点自动停止
    clockLoop: true, // 循环播放
    timeField: "datatime",
    positions: [
      {
        lng: 118.53243731,
        lat: 24.82483788,
        alt: 250,
        datatime: "2021/3/25 0:01:00",
      },
      {
        lng: 118.53006773,
        lat: 24.82339478,
        alt: 250,
        datatime: "2021/3/25 0:01:05",
      },
      {
        lng: 118.53006773,
        lat: 24.82339478,
        alt: 250,
        datatime: "2021/3/25 0:01:10",
      },
      {
        lng: 118.52950516,
        lat: 24.82305061,
        alt: 250,
        datatime: "2021/3/25 0:01:15",
      },
      {
        lng: 118.52678378,
        lat: 24.82138167,
        alt: 250,
        datatime: "2021/3/25 0:01:20",
      },
      {
        lng: 118.52483316,
        lat: 24.82029481,
        alt: 250,
        datatime: "2021/3/25 0:01:25",
      },
      {
        lng: 118.52155723,
        lat: 24.81866538,
        alt: 250,
        datatime: "2021/3/25 0:01:30",
      },
      {
        lng: 118.51975263,
        lat: 24.81771033,
        alt: 250,
        datatime: "2021/3/25 0:01:35",
      },
      {
        lng: 118.51713908,
        lat: 24.81650301,
        alt: 250,
        datatime: "2021/3/25 0:01:40",
      },
      {
        lng: 118.51501427,
        lat: 24.81547736,
        alt: 250,
        datatime: "2021/3/25 0:01:45",
      },
    ],
    camera: {
      type: "dy",
      followedX: 50,
      followedZ: 10,
    },
  });
  graphicLayer.addGraphic(fixedRoute);
}
export function clockTick(modelId) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");
  console.log(tilesetLayer, "tilesetLayer");
  tilesetLayer.on(mars3d.EventType.clockTick, function(event) {
    console.log("监听layer，时间对象", event);
  });
}
export function removePlanClipThing() {
  //去除已有剖切效果
  if (tileSetPlanClip && Vue.$GLOBAL.map.hasThing(tileSetPlanClip)) {
    tileSetPlanClip.clear();
    Vue.$GLOBAL.map.removeThing(tileSetPlanClip, true);
  }
}

export function startFun(modelId, horizontalData) {
  let tilesetLayer = Vue.$GLOBAL.map.getLayer(modelId, "modelId");

  //去除已有剖切效果
  console.log(tilesetLayer, "tilesetLayer");
  // tileSetPlanClip.clear();
  // Vue.$GLOBAL.map.removeThing(tileSetPlanClip, true);

  console.log(88888);
  tileSetPlanClip = new mars3d.thing.TilesetPlanClip({
    positions: horizontalData,
    layer: tilesetLayer,
    clipOutSide: false,
    edgeColor: Cesium.Color.GREY,
    type: mars3d.ClipType.ZR,
    edgeWidth: 2.0,
  });
}
export function sliderValChange(val) {
  console.log(tileSetPlanClip, "tileSetPlanClip");
  // tileSetPlanClip._distance = val;

  tileSetPlanClip.options.distance = val;
  tileSetPlanClip.distance = val;
}
